/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InventoryBlockHistoryUserDto } from './InventoryBlockHistoryUserDto';
export type InventoryBlockHistoryEntryDto = {
    /**
     * History record ID
     */
    id: number;
    /**
     * Availability action type
     */
    action: InventoryBlockHistoryEntryDto.action;
    /**
     * Optional user comment provided when blocking/unblocking
     */
    comment?: string;
    /**
     * Context where the action was performed
     */
    context?: InventoryBlockHistoryEntryDto.context;
    /**
     * Physical count session code (write-off entries only)
     */
    sessionCode?: string;
    /**
     * Timestamp when the action occurred
     */
    performedAt: string;
    /**
     * User who performed the action
     */
    performedBy?: InventoryBlockHistoryUserDto;
};
export namespace InventoryBlockHistoryEntryDto {
    /**
     * Availability action type
     */
    export enum action {
        BLOCK = 'BLOCK',
        UNBLOCK = 'UNBLOCK',
        WRITE_OFF = 'WRITE_OFF',
    }
    /**
     * Context where the action was performed
     */
    export enum context {
        WAREHOUSE = 'WAREHOUSE',
        BRANCH = 'BRANCH',
    }
}

